export default function Datenschutz() {
  return (
    <section className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Datenschutzerklärung</h1>
      <p>
        Wir, die Future Now UG, nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst.
        Personenbezogene Daten werden ausschließlich für die in dieser Anwendung beschriebenen
        Zwecke verarbeitet und nicht an Dritte weitergegeben, die nicht zur Erfüllung dieses
        Zwecks erforderlich sind.
      </p>
      <p className="mt-4">
        Verantwortlicher: Olaf Niggemann, Max‑Planck‑Str. 4, 85609 Aschheim, Deutschland.
        Bei Fragen zum Datenschutz können Sie uns jederzeit per E‑Mail an{" "}
        <a href="mailto:info@future-now.online" className="text-primary-500 hover:underline">
          info@future-now.online
        </a>{" "}
        kontaktieren.
      </p>
    </section>
  );
}